export default __webpack_public_path__ + "static/media/MAMMIFERE.a36f164b.svg";